'use client';
import { ArrowDownIcon } from '@/icons/ArrowDownIcon';
import { SearchIcon } from '@/icons/SearchIcon';
import { cn } from '@pulsex/utils';
import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import BurgerIcon from '@/icons/BurgerIcon';
import { CloseIcon } from '@/icons/CloseIcon';
import { Menu } from '@pulsex/models';
import { Logo } from '@/icons/Logo';
import { locale } from '@/locale';
import {
    BookmarkPageButton,
    FollowingPageButton,
    LoginUserButton,
    LogoutButton,
} from '../Login/Mobile';
import { FollowIcon } from '@/icons/FollowIcon';
import { ThemeToggle } from '../ThemeToggle/Index';
import { siteHref } from '@/utils/links';
import { JOSEPH_SAMAHA_ARCHIVE_PATH } from '@/constants';

type MenuProps = {
    menus: any;
    status?: string;
    scrolled?: boolean;
    scrollDirection?: string;
    pdfData?: any;
};

const MobileMenu = ({
    menus,
    status,
    scrolled = false,
    scrollDirection = '',
    pdfData,
}: MenuProps) => {
    const [showMenu, setShowMenu] = useState<boolean>(false);
    const [showSubMenu, setShowSubMenu] = useState<any>();
    const searchInputRef = useRef<HTMLInputElement>(null);
    const router = useRouter();
    const pathname = usePathname();

    const handleSubmit = (event?: React.FormEvent<HTMLFormElement>) => {
        if (event) event.preventDefault();

        const searchQuery = searchInputRef.current?.value;
        if (searchQuery) {
            searchQuery.trim().length > 2 && router?.push(`/search?q=${searchQuery.trim()}`);
        }
    };

    const dailyPdfURL = pdfData?.widgets?.[0]?.posts?.[0]?.publicUrl;

    useEffect(() => {
        if (showMenu) {
            document.body.style.overflowY = 'hidden';
        } else {
            document.body.style.overflowY = 'unset';
        }
    }, [showMenu]);

    function preventDefault(e: TouchEvent) {
        const target = e.target as HTMLElement | null;

        if (!target?.closest('#menu-container')) {
            e.preventDefault();
        }
    }

    useEffect(() => {
        function disableScroll() {
            document.addEventListener('touchmove', preventDefault, {
                passive: false,
            });
            document.body.style.overflow = 'hidden';
        }

        function enableScroll() {
            document.removeEventListener('touchmove', preventDefault);
            document.body.style.overflow = '';
        }

        if (showMenu) {
            disableScroll();
        } else {
            enableScroll();
        }

        return () => enableScroll();
    }, [showMenu]);

    return (
        <>
            <header
                className={cn(
                    'z-40 duration-200 bg-white mb-6',
                    scrollDirection === 'down' && 'sticky top-0 left-0',
                    showMenu && '!relative'
                )}
            >
                <nav
                    className={cn(
                        'flex flex-col pt-3.5 pb-3.5 md:pt-6 md:pb-6 container border-b shadow-sm'
                    )}
                >
                    <div className="flex justify-between items-center">
                        <Link href="/" aria-label="Home">
                            <Logo size={55} className="fill-black max-md:w-28" />
                        </Link>
                        <ThemeToggle className="mr-auto ml-2 w-9 h-9 md:w-11 md:h-11 p-1" iconSize={20} />
                        <a
                            href="https://en.al-akhbar.com/"
                            target="_blank"
                            aria-label="english website"
                            className="ml-2 md:ml-4 leading-3 rounded-full border p-1 w-9 h-9 md:w-11 md:h-11 grid place-items-center max-md:text-lg text-2xl "
                        >
                            EN
                        </a>
                        <LoginUserButton className="ml-2" />
                        <div
                            className="flex items-center justify-center h-fit p-1 bg-black rounded-full ml-2 md:ml-4"
                            onClick={() => setShowMenu(!showMenu)}
                        >
                            <BurgerIcon size={26} className="fill-white md:w-9 md:h-9" />
                        </div>
                        <a
                            href={JOSEPH_SAMAHA_ARCHIVE_PATH}
                            aria-label="joseph samaha"
                            className="w-fit"
                        >
                            <picture>
                                <source srcSet="/images/samaha.webp" type="image/webp" />
                                <img
                                    src="/images/samaha.png"
                                    alt="samaha"
                                    className="brightness-100 w-9 md:w-16 block select-none"
                                    style={{
                                        color: 'transparent',
                                        filter: 'contrast(1.2)',
                                        transform: 'scaleX(-1)',
                                    }}
                                    width={41}
                                    height={48}
                                />
                            </picture>
                        </a>
                    </div>
                    {/* <div className="flex mt-4 justify-between">
            <div
              className="flex items-center justify-center h-fit px-1 py-1 bg-black rounded-lg"
              onClick={() => setShowMenu(!showMenu)}
            >
              <BurgerIcon size={28} className="fill-white" />
            </div>

            <div
              className={cn(
                "max-w-[200px] w-full h-[38px] rounded-full border"
              )}
            >
              <form
                className="items-center h-full w-full py-2 px-2.5"
                onSubmit={handleSubmit}
              >
                <label
                  htmlFor="default-search"
                  className="mb-2 text-sm font-medium text-white sr-only hidden"
                >
                  {locale.search}
                </label>
                <div className="relative flex justify-between items-center">
                  <input
                    type="search"
                    id="default-search"
                    ref={searchInputRef}
                    className={cn(
                      "m-auto block w-full bg-white text-center",
                      "focus:ring-white/0 focus:border-none outline-0 !rounded-none"
                    )}
                    placeholder={locale.searchPlaceHolder}
                    required
                  />
                  <div
                    onClick={() => handleSubmit()}
                    className="flex items-center cursor-pointer z-10"
                  >
                    <SearchIcon size={20} className="fill-black/85" />
                  </div>
                </div>
              </form>
            </div>
          </div> */}
                </nav>

                {showMenu && (
                    <>
                        <div
                            id="menu-container"
                            className={cn(
                                // fixed inset-0 min-h-screen h-[calc(100vh-15px)]
                                'overflow-y-scroll absolute top-0 w-screen h-[100dvh]',
                                ' z-50 flex flex-col bg-lightgreyBackground'
                            )}
                            // style={{height:"-webkit-fill-available"}}
                        >
                            <div className="w-full px-4 mt-4 mb-6 flex items-center gap-3">
                                <div
                                    className="bg-black w-fit z-50 p-1 rounded-lg"
                                    onClick={() => {
                                        setShowMenu(false);
                                        setShowSubMenu(false);
                                    }}
                                >
                                    <CloseIcon size={30} className="fill-white" />
                                </div>
                                <Link
                                    href={siteHref(dailyPdfURL)}
                                    className="w-9 h-9 flex items-center justify-center"
                                >
                                    <img
                                        src="/images/pdf.png"
                                        alt="PDF"
                                        className="w-6"
                                        width={30}
                                        height={30}
                                        style={{ filter: 'contrast(1.2)' }}
                                    />
                                </Link>
                                <BookmarkPageButton />
                                <FollowingPageButton />
                                <LogoutButton clickEvent={() => setShowMenu(false)} />
                            </div>

                            <div className="block">
                                <div
                                    className={cn(
                                        'mx-auto w-[95%] h-[48px] rounded-xl border mb-4'
                                    )}
                                >
                                    <form
                                        className="items-center h-full w-full py-2 px-2.5 bg-[#e5e5e5]"
                                        onSubmit={handleSubmit}
                                    >
                                        <label
                                            htmlFor="default-search"
                                            className="mb-2 text-xl font-medium text-white sr-only hidden"
                                        >
                                            {locale.search}
                                        </label>
                                        <div className="relative flex justify-between items-center">
                                            <input
                                                type="search"
                                                id="default-search"
                                                ref={searchInputRef}
                                                className={cn(
                                                    'm-auto block w-full text-2xl text-right bg-transparent font-amine-light',
                                                    'focus:ring-white/0 focus:border-none outline-0 !rounded-none'
                                                )}
                                                placeholder={locale.searchPlaceHolder}
                                                required
                                            />
                                            <div
                                                onClick={() => handleSubmit()}
                                                className="flex items-center cursor-pointer z-10"
                                            >
                                                <SearchIcon size={22} className="fill-black/85" />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                {menus?.menus['h-main']?.map((menuItem: any, index: number) => (
                                    <div
                                        key={index}
                                        className={cn(
                                            'block border-b border-gray-300 justify-center text-2xl text-white font-medium',
                                            showSubMenu === index && `show-sub-menu-${index}`
                                        )}
                                    >
                                        <div
                                            aria-label={menuItem?.title}
                                            className={cn(
                                                'rtl:pl-6 ltr:pr-6 py-3 flex items-end justify-between text-black ',
                                                'border-r-[14px]',
                                                pathname.length > 2 &&
                                                    menuItem?.url?.includes(
                                                        pathname?.split('/')[1]
                                                    ) &&
                                                    'relative'
                                            )}
                                            style={{
                                                borderRight: `14px solid ${
                                                    menuItem?.color || menuItem?.icon || '#bfbfbf'
                                                }`,
                                            }}
                                            onClick={() => {
                                                if (menuItem?.subMenus?.length) {
                                                    setShowSubMenu(
                                                        showSubMenu === index ? undefined : index
                                                    );
                                                } else {
                                                    setShowMenu(false);
                                                }
                                            }}
                                        >
                                            {menuItem?.subMenus?.length > 0 ? (
                                                <div className="" style={{ marginRight: '14px' }}>
                                                    {menuItem?.title}
                                                </div>
                                            ) : (
                                                <Link
                                                    href={siteHref(menuItem?.url)}
                                                    style={{ marginRight: '14px' }}
                                                    className=""
                                                >
                                                    {menuItem?.title}
                                                </Link>
                                            )}
                                            {menuItem?.subMenus?.length > 0 && (
                                                <ArrowDownIcon
                                                    size={16}
                                                    className={cn(
                                                        'ml-1.5 -translate-y-[3px] transition-transform duration-100 fill-black hover:fill-primary',
                                                        showSubMenu === index && 'rotate-180'
                                                    )}
                                                />
                                            )}
                                        </div>

                                        {menuItem?.subMenus?.length > 0 && (
                                            <div
                                                className={cn(
                                                    ' bg-[#efefef] text-xl  space-y-0 items-start ltr:text-left',
                                                    showSubMenu === index ? 'block' : 'hidden',
                                                    'text-black border-r-[14px]'
                                                )}
                                                style={{
                                                    borderRight: `14px solid ${
                                                        menuItem?.color || menuItem?.icon || ''
                                                    }`,
                                                }}
                                            >
                                                {menuItem?.title !== locale.more ? (
                                                    <Link
                                                        href={siteHref(menuItem?.url)}
                                                        aria-label={menuItem?.title}
                                                        className="border-gray-300 border-b border-t p-3 w-full block"
                                                    >
                                                        {menuItem?.title}
                                                    </Link>
                                                ) : (
                                                    ''
                                                )}
                                                {menuItem?.subMenus?.map(
                                                    (subItem: any, subIndex: number) => {
                                                        // if (subItem.url === '/ziad') return;
                                                        return (
                                                            <Link
                                                                key={subIndex}
                                                                className={cn(
                                                                    'border-gray-300 px-3 w-full py-3 block',
                                                                    subIndex !==
                                                                        menuItem?.subMenus?.length -
                                                                            1 && 'border-b',
                                                                    menuItem?.title ===
                                                                        locale.more &&
                                                                        subIndex === 0 &&
                                                                        'border-t',
                                                                    `group/${menuItem?.title}`
                                                                )}
                                                                href={siteHref(
                                                                    decodeURIComponent(
                                                                        subItem?.title
                                                                    ) === locale.todaysRelease &&
                                                                        dailyPdfURL
                                                                        ? dailyPdfURL
                                                                        : subItem?.url
                                                                )}
                                                                aria-label={subItem?.title}
                                                                onClick={() => {
                                                                    setShowMenu(false);
                                                                    setShowSubMenu(false);
                                                                }}
                                                            >
                                                                {subItem?.title}
                                                            </Link>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div
                            onClick={() => setShowMenu(false)}
                            className={cn(
                                'fixed w-screen h-screen top-0 left-0',
                                'transition-all duration-100 opacity-0 overflow-y-scroll',
                                showMenu ? 'z-20 bg-lightgreyBackground opacity-100' : 'z-[-1]'
                            )}
                        ></div>
                    </>
                )}
            </header>
        </>
    );
};

export default MobileMenu;
